module.exports = __webpack_public_path__ + "static/media/word.af700f17.svg";